import { createContext } from 'react';

const PlanDateContext = createContext({});

export default PlanDateContext;
